const calendarES = {
	loading: "Cargando tu horario...",
	title: "Mi Calendario",
	break: "descanso",

	sub: {
		adjusting: "Ajusta tus horas de trabajo base",
		default: "Haz clic en una hora para agregar un evento personal",
	},

	toolbar: {
		thisWeek: "Esta Semana",
		today: "Hoy",
		closeEditor: "Cerrar editor de horario",
		editSchedule: "Editar horario base",
		day: "Ver día",
		week: "Ver semana",
		blockTime: "Cerrar franja horaria",
	},

	editSchedule: "Horario del personal",
	addWalkIn: "Agregar sin cita",

	editor: {
		title: "Horario semanal de trabajo",
		subtitle: "Activa los días abiertos y ajusta las horas de inicio y fin.",

		hours: "Horas de trabajo",
		breaks: "Descansos",

		closed: "Cerrado",
		cancel: "Cancelar",
		save: "Guardar",
		saving: "Guardando...",
	},

	breaks: {
		title: "Descansos recurrentes",
		subtitle: "Agrega descansos o almuerzos que se repiten cada semana.",
		add: "+ Añadir descanso",
	},

	popup: {
		addEventTitle: "Agregar evento personal",
		title: "Título",
		placeholderTitle: "ej. Almuerzo con cliente",
		start: "Inicio",
		end: "Fin",
		description: "Descripción",
		placeholderDesc: "Agrega notas o detalles...",
		cancel: "Cancelar",
		addEvent: "Agregar evento",
	},

	details: {
		noDescription: "No se proporcionó descripción",
		close: "Cerrar",

		services: "Servicios",
		reassignLabel: "Reasignar a miembro del equipo",
		noAvailableStaff: "No hay personal disponible para este horario.",
		selectStaff: "Seleccionar personal…",
		reassign: "Reasignar",
		cancelBooking: "Cancelar cita",
		confirmCancelTitle: "Cancelar cita",
		confirmCancelText: "¿Estás seguro de que deseas cancelar esta cita? Esta acción no se puede deshacer.",
		confirmCancelNo: "Mantener cita",
		confirmCancelYes: "Sí, cancelar",
	},

	empty: {
		noStaffWorking: "No hay personal trabajando hoy",
		updateHint: "Actualiza los horarios del personal para mostrar disponibilidad",

		noScheduleToday: "Sin horario hoy",
		notWorking: "No trabajas este día",
	},

	/* Copy for the quick-add sheet — the one that opens on tapping an
	   empty calendar slot. walkIn/blockTime are the mode toggle's labels
	   and are unchanged from what shipped; the rest arrived with the
	   duration controls. Spanish follows the terms this app already uses
	   (walkin.title "Agregar cita", and the confirm button's own
	   "Bloquear tiempo"). */
	quickAdd: {
		walkIn: "Cita",
		blockTime: "Bloquear tiempo",

		titleWalkIn: "Nueva cita",
		titleBlock: "Bloquear tiempo",

		startsAt: "Comienza a las",
		duration: "Duración",
		services: "Servicios",
		client: "Nombre del cliente",
		reason: "Motivo",
		reasonPlaceholder: "Descanso, diligencia, limpieza…",

		minutesShort: "min",
		hourShort: "h",
		max: "máx",
		less: "Más corto",
		more: "Más largo",
		matchServices: "Ajustar a servicios",
		homeService: "A domicilio",

		freeWindow: "{minutes} libres — hasta las {time}",
		noRoom: "No queda tiempo libre en este horario.",

		cancel: "Cancelar",
		confirmWalkIn: "Agregar cita",
		confirmBlock: "Bloquear tiempo",
		saving: "Guardando…",

		errorWalkIn: "No pudimos agregar la cita. Inténtalo de nuevo.",
		errorBlock: "No pudimos bloquear el tiempo. Inténtalo de nuevo.",
	},

	walkin: {
		title: "Agregar cita",
		close: "Cerrar",

		timePeriods: {
			morning: "Mañana",
			afternoon: "Tarde",
			evening: "Noche",
		},

		noSlots: "No hay horarios disponibles para este período.",

		staff: {
			select: "Seleccionar personal",
		},

		service: {
			label: "Servicio",
			none: "Este miembro del equipo no tiene servicios asignados. Configura los servicios del negocio primero.",
			placeholder: "Seleccionar servicio",
		},

		duration: {
			label: "Duración",
			edit: "Editar",
			done: "Listo",
			minutes: "min",
		},

		client: {
			label: "Nombre del cliente (opcional)",
			placeholder: "Sin cita",
		},

		validation: {
			selectStaff: "Selecciona un miembro del equipo.",
			selectService: "Selecciona un servicio.",
			selectTime: "Selecciona un horario.",
			pastTime: "No puedes crear una cita en el pasado.",
		},

		footer: {
			noService: "Ningún servicio seleccionado",
			saving: "Guardando...",
			confirm: "Agregar sin cita",
		},

		toast: {
			success: "Sin cita agregada correctamente",
			error: "No se pudo crear la sin cita. Intenta nuevamente.",
		},
	},
	exclusion: {
		title: "Bloquear tiempo / Vacaciones",

		startDate: "Fecha de inicio",
		endDate: "Fecha de fin",

		fullDay: "Todo el día",
		fullDayLabel: "Todo el día",

		startTime: "Hora de inicio",
		endTime: "Hora de fin",

		reasonLabel: "Motivo (opcional)",
		reasonPlaceholder: "Vacaciones, libre, cerrado, etc.",

		existing: "Horarios bloqueados existentes",

		save: "Guardar",
		saving: "Guardando...",
		conflictsBanner: "Tienes {count} reserva(s) en este rango. Cancélalas o reasígnalas primero.",
		overlapBanner: "Este bloqueo se superpone con otro existente",
		reasonDefault: "No disponible",

		toast: {
			saved: "Tiempo bloqueado correctamente",
			error: "No se pudo bloquear el tiempo",
			removed: "Eliminado",
			removeError: "Error al eliminar el bloqueo",
		},
	},

	errors: {
		loadWeek: "No pudimos cargar tu calendario. Inténtalo de nuevo.",
		reload: "No pudimos actualizar el calendario.",
		saveBlock: "No pudimos guardar el bloqueo. Inténtalo de nuevo.",
	},
};

export default calendarES;
